import { css } from '@emotion/core'
import useDSApplicationMode from '../hooks/useDSApplicationMode'

const appMode = useDSApplicationMode()
const touchScreen = appMode === 'KIOSK' || appMode === 'STATION'
export default css`
  body {
    ${touchScreen
      ? `-webkit-touch-callout: none;
        -webkit-user-select: none;
         -khtml-user-select: none;
           -moz-user-select: none; 
            -ms-user-select: none;
                user-select: none;
      `
      : ''}
  }
`
